function fadeIn(el, duration = 400, display = 'flex') {
  el.style.opacity = '0';
  el.style.display = display;
  el.style.transition = `opacity ${duration}ms`;
  void el.offsetWidth;
  el.style.opacity = '1';
}

function fadeOut(el, duration = 400) {
  el.style.transition = `opacity ${duration}ms`;
  el.style.opacity = '0';
  setTimeout(() => {
    el.style.display = 'none';
  }, duration);
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('a.open-popup');
  if (!trigger) return;

  event.preventDefault();

  const overlay = document.getElementById(trigger.dataset.overlay);
  const popup = document.getElementById(trigger.dataset.target);
  if (!overlay || !popup) return;

  // Embed popup inside the overlay
  overlay.appendChild(popup);
  popup.style.display = '';
  popup.style.opacity = '';

  fadeIn(overlay);
  document.body.classList.add('no-scroll');

  const onKey = (e) => {
    if (e.key === 'Escape') close();
  };

  const onOverlayClick = (e) => {
    // Only close if click landed on the overlay backdrop, not the popup
    if (e.target === overlay) close();
  };

  const close = () => {
    fadeOut(overlay);
    document.body.classList.remove('no-scroll');
    document.removeEventListener('keyup', onKey);
    overlay.removeEventListener('click', onOverlayClick);
  };

  overlay.addEventListener('click', onOverlayClick);
  document.addEventListener('keyup', onKey);
});